import React from 'react';
import PropTypes from 'prop-types';
import CheckmarkIcon from '@components/icons/CheckmarkIcon';
import Tooltip from '../common/Tooltip';

const ChecklistItem = ({ caption, tooltipMessage }) => {
	return (
		<div className='d-flex'>
			<CheckmarkIcon className='mt-1' />
			<div className={`caption pl-2 ${tooltipMessage ? 'mr-2' : ''}`}>{caption}</div>
			{tooltipMessage && <Tooltip message={tooltipMessage} />}
		</div>
	);
};

ChecklistItem.propTypes = {
	caption: PropTypes.string.isRequired,
	tooltipMessage: PropTypes.string,
};

export default ChecklistItem;
